var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-search" },
    [
      _c(
        "div",
        {
          staticClass: "search-container",
          on: {
            click: function($event) {
              _vm.isOpened = !_vm.isOpened
            },
            focusout: _vm.handleFocusOut
          }
        },
        [
          _c("input", {
            staticClass: "search-input",
            attrs: {
              type: "text",
              "aria-placeholder": _vm.placeholder,
              placeholder: _vm.placeholder
            },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event.target.value)
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.$emit("search")
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "search-button",
              on: {
                click: function($event) {
                  return _vm.$emit("search")
                }
              }
            },
            [_c("k-icon", { staticClass: "icon", attrs: { icon: "search1" } })],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-down" } }, [
        _vm.isOpened && _vm.results && _vm.filteredResults.length > 0
          ? _c("div", { staticClass: "search-results" }, [
              _c("h3", { staticClass: "title" }, [
                _vm._v("\n        " + _vm._s(_vm.results.title) + "\n      ")
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "results-list" },
                _vm._l(_vm.filteredResults, function(result, index) {
                  return _c(
                    "li",
                    {
                      key: "result-" + index,
                      staticClass: "results-item",
                      on: {
                        click: function($event) {
                          return _vm.clickSuggestion(result.name)
                        }
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "search-suggestion",
                          on: {
                            click: function($event) {
                              return _vm.clickSuggestion(result.name)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(result.name) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close-button",
                          on: {
                            click: function($event) {
                              return _vm.$emit("remove-item", result)
                            }
                          }
                        },
                        [
                          _c("k-icon", {
                            staticClass: "close",
                            attrs: { icon: "close" }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86f558dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86f558dc","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/kaledo-components/src/components/KSearch.vue
// module id = 2070
// module chunks = 1610